import { render } from "./journalhis.vue?vue&type=template&id=551760a2&scoped=true"
import script from "./journalhis.vue?vue&type=script&lang=js"
export * from "./journalhis.vue?vue&type=script&lang=js"

import "./journalhis.vue?vue&type=style&index=0&id=551760a2&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551760a2"]])

export default __exports__